import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { CashIsleLogo } from "@/components/CashIsleLogo";
import { Helmet } from "react-helmet-async";

interface Props {
  title: string;
  description: string;
  updated: string;
  children: React.ReactNode;
}

export const LegalLayout = ({ title, description, updated, children }: Props) => {
  return (
    <main className="min-h-screen bg-background text-foreground">
      <Helmet>
        <title>{`${title} — Cash Isle`}</title>
        <meta name="description" content={description} />
      </Helmet>
      <header className="border-b border-border">
        <div className="max-w-3xl mx-auto px-5 py-4 flex items-center gap-3">
          <Link to="/" aria-label="Back to home" className="p-1 -ml-1 rounded-lg hover:bg-muted">
            <ArrowLeft className="h-5 w-5" />
          </Link>
          <CashIsleLogo size={28} />
          <span className="font-display font-bold">Cash Isle</span>
        </div>
      </header>
      <article className="max-w-3xl mx-auto px-5 py-8 prose prose-sm sm:prose-base prose-headings:font-display prose-headings:text-foreground prose-p:text-foreground/90 prose-li:text-foreground/90 prose-strong:text-foreground prose-a:text-primary max-w-none">
        <h1 className="!mb-1">{title}</h1>
        <p className="text-xs text-muted-foreground !mt-0">Last updated: {updated}</p>
        {children}
        <hr className="my-10" />
        <p className="text-xs text-muted-foreground">
          Questions? Email{" "}
          <a href="mailto:support@cashisle.app">support@cashisle.app</a>.
        </p>
      </article>
    </main>
  );
};
